import {
  Button,
  Collapse,
  Divider,
  IconButton,
  makeStyles,
  MenuItem,
  Paper,
  TextField,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Alert from "@material-ui/lab/Alert";
import { KeyboardTimePicker } from "@material-ui/pickers";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { beachActions, beachSelectors, citySelectors } from "../../redux";
import { getHHmmFromString } from "../../utils";
import BeachSelector from "../BeachSelector";
import useFormBeach, { BeachFormType } from "./useFormBeach";

interface FormBeachProps {}

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  buttonGroup: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  actionButtons: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  logoWrapper: {
    display: "grid;",
    justifyContent: "center",
  },
  logoImage: {
    borderRadius: "50%",
  },
  logoText: {
    marginTop: theme.spacing(2),
    fontSize: "12px",
  },
  logoPlaceholder: {
    fontSize: "50px",
  },
  fabPlaceholder: {
    backgroundColor: "transparent",
    width: "70px",
    height: "70px",
  },
  fabLogo: {
    width: "150px",
    height: "150px",
  },
  input: {
    display: "none",
  },
}));

const FormBeach: React.FC<FormBeachProps> = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const beach = useSelector(beachSelectors.getBeach);
  const updatedBeach = useSelector(beachSelectors.getUpdatedBeach);
  const createdBeach = useSelector(beachSelectors.getCreatedBeach);
  const cities = useSelector(citySelectors.getAllCitiesAsOption);
  const { errors, register, control, reset, handleSubmit } = useFormBeach();
  const [hasBeenRequested, setHasBeenRequested] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(true);
  // const logoInputRef = useRef<HTMLInputElement>(null);
  // const [uploadedLogo, setUploadedLogo] = useState<any>("");
  // const [blob, setBlob] = useState<Blob | null>(null);

  useEffect(() => {
    return () => {
      dispatch(beachActions.clear("beach"));
    };
  }, [dispatch]);

  useEffect(() => {
    if (beach.data) {
      reset({
        bookingTimeLimit: beach.data.bookingTimeLimit,
        city: beach.data.city,
        closingTime:
          beach.data.closingTime && getHHmmFromString(beach.data.closingTime),
        id: beach.data.id,
        maxBookingTime:
          beach.data.maxBookingTime && Number(beach.data.maxBookingTime) / 60,
        minBookingTime:
          beach.data.minBookingTime && Number(beach.data.minBookingTime) / 60,
        openingTime:
          beach.data.openingTime && getHHmmFromString(beach.data.openingTime),

        peoplePerSeat: beach.data.peoplePerSeat,
        name: beach.data.name,
        rows: beach.data.rows,
        lat: beach.data.location?.latitude,
        lng: beach.data.location?.longitude,
        seatsPerRow: beach.data.seatsPerRow,
      });
    }
  }, [beach, reset]);

  // const handleUploadLogoClick = () => {
  //   logoInputRef.current?.click();
  // };

  // const handleChangeUploadLogo = (event: any) => {
  //   const reader = new FileReader();
  //   reader.onload = function (e: any) {
  //     setBlob(e?.target.result);
  //   };
  //   if (event.target.files[0]) {
  //     setUploadedLogo(URL.createObjectURL(event.target.files[0]));
  //   }
  //   //servizio di upload blob
  // };

  const onSubmit = (data: BeachFormType) => {
    if (beach.data?.id) {
      dispatch(
        beachActions.updateBeach({
          id: data.id,
          bookingTimeLimit: data.bookingTimeLimit,
          location: {
            latitude: data.lat,
            longitude: data.lng,
          },
          city: data.city,
          closingTime:
            data.closingTime && format(new Date(data.closingTime), "HHmm"),
          maxBookingTime:
            data.maxBookingTime && Number(data.maxBookingTime) * 60,
          minBookingTime:
            data.minBookingTime && Number(data.minBookingTime) * 60,
          name: data.name,
          openingTime:
            data.openingTime && format(new Date(data.openingTime), "HHmm"),
          peoplePerSeat: data.peoplePerSeat,
          rows: Number(data.rows),
          seats: beach.data?.seats || [],
          seatsPerRow: Number(data.seatsPerRow),
        })
      );
    } else {
      dispatch(
        beachActions.createBeach({
          bookingTimeLimit: Number(data.bookingTimeLimit),
          location: {
            latitude: data.lat,
            longitude: data.lng,
          },
          city: data.city,
          closingTime:
            data.closingTime && format(new Date(data.closingTime), "HHmm"),
          maxBookingTime:
            data.maxBookingTime && Number(data.maxBookingTime) * 60,
          minBookingTime:
            data.minBookingTime && Number(data.minBookingTime) * 60,
          name: data.name,
          openingTime:
            data.openingTime && format(new Date(data.openingTime), "HHmm"),
          peoplePerSeat: data.peoplePerSeat,
          rows: Number(data.rows),
          seats: beach.data?.seats || [],
          seatsPerRow: Number(data.seatsPerRow),
        })
      );
    }
    setHasBeenRequested(true);
  };

  console.log(cities);
  return (
    <Paper className={classes.paper} variant="outlined" square>
      {/* {uploadedLogo !== "" ? (
        <>
          <Fab onClick={handleUploadLogoClick} className={classes.fabLogo}>
            <img
              height="150"
              width="150"
              src={uploadedLogo}
              alt="logo"
              className={classes.logoImage}
            />
          </Fab>
        </>
      ) : (
        <label htmlFor="contained-button-file">
          <div className={classes.logoWrapper}>
            <Fab
              onClick={handleUploadLogoClick}
              className={classes.fabPlaceholder}
            >
              <PhotoCameraIcon
                className={classes.logoPlaceholder}
                color="primary"
              />
            </Fab>
          </div>
        </label>
      )} */}
      <Collapse
        in={
          (!beach.isLoading ||
            !updatedBeach.isLoading ||
            !createdBeach.isLoading) &&
          hasBeenRequested &&
          isAlertOpen
        }
      >
        <Alert
          color={updatedBeach.error || createdBeach.error ? "error" : "success"}
          severity={
            createdBeach.error || updatedBeach.error ? "error" : "success"
          }
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setIsAlertOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {updatedBeach.error || createdBeach.error
            ? "Si è verificato un errore"
            : "Dato aggiunto correttamente"}
        </Alert>
      </Collapse>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input type="hidden" name="id" ref={register}></input>
        <TextField
          label="Nome completo"
          helperText={errors.name?.message}
          error={!!errors.name}
          name="name"
          inputRef={register}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
        />
        <TextField
          label="Ore minime di prenotazione"
          helperText={errors.minBookingTime?.message}
          error={!!errors.minBookingTime}
          name="minBookingTime"
          inputRef={register}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          type="number"
          variant="outlined"
        />
        <TextField
          label="Ore massime di prenotazione"
          helperText={errors.maxBookingTime?.message}
          error={!!errors.maxBookingTime}
          name="maxBookingTime"
          inputRef={register}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          type="number"
          variant="outlined"
        />
        <TextField
          label="Quanti giorni prima è possibile prenotare"
          helperText={errors.bookingTimeLimit?.message}
          error={!!errors.bookingTimeLimit}
          name="bookingTimeLimit"
          inputRef={register}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          type="number"
          variant="outlined"
        />
        <TextField
          label="Latitudine"
          helperText={errors.lat?.message}
          error={!!errors.lat}
          name="lat"
          inputRef={register}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          type="text"
          variant="outlined"
        />
        <TextField
          label="Longitudine"
          helperText={errors.lng?.message}
          error={!!errors.lng}
          name="lng"
          inputRef={register}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          type="text"
        />
        <TextField
          label="Numero massime di persone per posto"
          helperText={errors.peoplePerSeat?.message}
          error={!!errors.peoplePerSeat}
          name="peoplePerSeat"
          inputRef={register}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          type="number"
          variant="outlined"
        />

        <Controller
          as={
            <TextField
              select
              margin="normal"
              label="Città"
              fullWidth
              helperText={errors.city?.message}
              error={!!errors.city}
              variant="outlined"
            >
              {cities?.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          }
          name="city"
          defaultValue=""
          control={control}
        />
        <Controller
          as={
            <KeyboardTimePicker
              helperText={errors.openingTime?.message}
              error={!!errors.openingTime}
              fullWidth
              margin="normal"
              value=""
              onChange={() => {}}
              inputVariant="outlined"
              label="Orario di apertura"
              autoOk
              KeyboardButtonProps={{
                "aria-label": "change time",
              }}
              InputLabelProps={{ shrink: true }}
            />
          }
          name="openingTime"
          defaultValue=""
          control={control}
        />
        <Controller
          as={
            <KeyboardTimePicker
              helperText={errors.closingTime?.message}
              error={!!errors.closingTime}
              fullWidth
              margin="normal"
              inputVariant="outlined"
              label="Orario di chiusura"
              value=""
              InputLabelProps={{ shrink: true }}
              onChange={() => {}}
              KeyboardButtonProps={{
                "aria-label": "change time",
              }}
            />
          }
          name="closingTime"
          control={control}
          defaultValue=""
        />
        <Divider className={classes.divider}></Divider>
        <TextField
          label="Numero file"
          helperText={errors.rows?.message}
          error={!!errors.rows}
          name="rows"
          inputRef={register}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          type="number"
          variant="outlined"
        />
        <TextField
          label="Numero posti"
          helperText={errors.seatsPerRow?.message}
          error={!!errors.seatsPerRow}
          name="seatsPerRow"
          inputRef={register}
          fullWidth
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
          type="number"
          variant="outlined"
        />
        <Controller
          as={
            <TextField
              select
              margin="normal"
              label="Tipologia account"
              fullWidth
              helperText={errors.accountType?.message}
              error={!!errors.accountType}
              variant="outlined"
            >
              <MenuItem key="basic" value="basic">
                Base
              </MenuItem>
              <MenuItem key="premium" value="premium">
                Premium
              </MenuItem>
            </TextField>
          }
          name="accountType"
          defaultValue=""
          control={control}
        />
        <div className={classes.buttonGroup}>
          <Button
            size="large"
            type="submit"
            variant="contained"
            color="primary"
          >
            {beach.data?.id ? "Aggiorna" : "Aggiungi"}
          </Button>

          {/* <input
            id="contained-button-file"
            accept="image/*"
            className={classes.input}
            ref={logoInputRef}
            multiple
            type="file"
            onChange={handleChangeUploadLogo}
          /> */}
          {/*  <div className={classes.actionButtons}>
            <label htmlFor="contained-button-file">
              <Fab
                onClick={handleUploadLogoClick}
                variant="extended"
                color="primary"
              >
                <AddIcon></AddIcon>

                {uploadedLogo === "" ? "carica logo" : "modifica logo"}
              </Fab>
            </label>
          </div> */}
        </div>
        {beach.data &&
          beach.data.seats &&
          beach.data.seatsPerRow &&
          beach.data.peoplePerSeat &&
          beach.data.id && (
            <BeachSelector
              beachId={beach.data.id}
              maxPeople={beach.data.peoplePerSeat}
              seats={beach.data.seats}
              seatsPerRow={beach.data.seatsPerRow}
              rows={beach.data.seatsPerRow}
            ></BeachSelector>
          )}
      </form>
    </Paper>
  );
};

export default FormBeach;
